import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { additionalValue } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';
import { useParams, useSearch } from '@tanstack/react-router';

export const useGetPlanList = () => {
  const search = useSearch({
    from: '/(app)/store-information/premium-stores/plan-management/$clubid/',
  });
  const { page, fetch, q, createdDate } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });

  const { clubid } = useParams({
    from: '/(app)/store-information/premium-stores/plan-management/$clubid/',
  });

  const { data, isLoading } = useQuery({
    ...planManagementQueries.list({
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
      clubId: clubid,
      row: page ?? 1,
      fetch: fetch ?? 10,
      search: q,
    }),
    select: (res) => {
      return {
        ...res,
        data: res.data,
      };
    },
  });
  return {
    data: data?.data || [],
    isLoading: isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
    commonClubId: (data?.meta?.additionalValue || '') as additionalValue,
  };
};
